
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("iwt54", function(module, exports) {
$parcel$export(module.exports, "ExternalCollaboratorsSpaceInformationMessage", () => (parcelRequire("6lvbX")).ExternalCollaboratorsSpaceInformationMessage);
$parcel$export(module.exports, "ExternalCollaboratorsSpaceInformationMessageType", () => (parcelRequire("6lvbX")).ExternalCollaboratorsSpaceInformationMessageType);
$parcel$export(module.exports, "ExternalCollaboratorsSpaceInformationMessageBanner", () => (parcelRequire("buzhH")).ExternalCollaboratorsSpaceInformationMessageBanner);
$parcel$export(module.exports, "ExternalCollaboratorsSpaceInformationMessageFooter", () => (parcelRequire("a04nk")).ExternalCollaboratorsSpaceInformationMessageFooter);
$parcel$export(module.exports, "SpaceExternalListScrollable", () => (parcelRequire("lWGeX")).SpaceExternalListScrollable);

var $6lvbX = parcelRequire("6lvbX");


var $buzhH = parcelRequire("buzhH");


var $a04nk = parcelRequire("a04nk");


var $lWGeX = parcelRequire("lWGeX");


});

parcelRegister("6lvbX", function(module, exports) {

var $hdRN9 = parcelRequire("hdRN9");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $jMyy4 = parcelRequire("jMyy4");


var $inPa6 = parcelRequire("inPa6");


var $eEA8O = parcelRequire("eEA8O");


var $a3fRD = parcelRequire("a3fRD");


var $eXmBZ = parcelRequire("eXmBZ");


var $6xdDU = parcelRequire("6xdDU");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $7QM6o = parcelRequire("7QM6o");


var $cLo2u = parcelRequire("cLo2u");


var $13WZn = parcelRequire("13WZn");

const $e305cd57fd097c2e$var$ExternalCollaboratorsSpaceInformationMessageQuery = (0, $hdRN9.default);
const $e305cd57fd097c2e$var$i18n = (0, $h82at.defineMessages)({
    spaceNavigationMessageLink: {
        id: "space-guest-list.external-collaborator-message.navigation.guests-access-to-space",
        defaultMessage: "{guestCallToAction} in this space"
    },
    spaceMessageLink: {
        id: "space-guest-list.external-collaborator-message.space.guests-access-to-space",
        defaultMessage: "{guestCallToAction} {guestCount, plural, one {has} other {have}} access to this space."
    },
    pageMessageLink: {
        id: "space-guest-list.external-collaborator-message.page.guests-access-to-page",
        defaultMessage: "{guestCallToAction} can access."
    },
    pageMessageLinkWithSeparateCallToAction: {
        id: "space-guest-list.external-collaborator-message.page.guests-access-to-page-cta",
        defaultMessage: "{guests} can access. {callToAction}"
    },
    additionalContextMessage: {
        id: "space-guest-list.external-collaborator-message.guest-context",
        defaultMessage: "Guests are external to your organization."
    },
    guestCallToActionMessage: {
        id: "space-guest-list.external-collaborator-message.guest-count",
        defaultMessage: "{guestCount, plural, =0 {No guests} one {# guest} other {# guests}}"
    },
    callToActionMessage: {
        id: "space-guest-list.external-collaborator-message.view-guest-action",
        defaultMessage: "{guestCount, plural, one {View guest} other {View guests}}"
    },
    errorMessage: {
        id: "space-guest-list.external-collaborator-message.error",
        defaultMessage: "An error occurred while retrieving guests."
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e305cd57fd097c2e$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulppxbi _1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e305cd57fd097c2e$var$IconWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e305cd57fd097c2e$var$MessageWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSubtlest: isSubtlest, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _1e0c1txw",
            __cmplp.isSubtlest ? "_syaz1rpy" : "_syazazsu",
            __cmplp.className
        ])
    });
});
const $e305cd57fd097c2e$var$MessageButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSubtlest: isSubtlest, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_19zy1r31 _5fak8stv _q1zanqa1 _13gm1r31 _gms98stv _1ddtnqa1 _143jazsu",
            __cmplp.isSubtlest ? "_8avf1rpy" : "_8avfazsu",
            __cmplp.className
        ])
    });
});
const $e305cd57fd097c2e$var$NullButtonWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "",
            __cmplp.className
        ])
    });
});
const $e305cd57fd097c2e$var$MessageSkeleton = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _2rko12b0 _1e0c1txw _bfhki8nm",
            __cmplp.className
        ])
    });
});
var $e305cd57fd097c2e$export$d804669af4df8a67 = /*#__PURE__*/ function(ExternalCollaboratorsSpaceInformationMessageType) {
    ExternalCollaboratorsSpaceInformationMessageType["IN_SPACE"] = "IN_SPACE";
    ExternalCollaboratorsSpaceInformationMessageType["ACCESS_TO_SPACE"] = "ACCESS_TO_SPACE";
    ExternalCollaboratorsSpaceInformationMessageType["ACCESS_TO_PAGE"] = "ACCESS_TO_PAGE";
    ExternalCollaboratorsSpaceInformationMessageType["ACCESS_TO_PAGE_CTA"] = "ACCESS_TO_PAGE_CTA";
    return ExternalCollaboratorsSpaceInformationMessageType;
}({});
const $e305cd57fd097c2e$var$PRIMARY_MESSAGE = {
    ["IN_SPACE"]: $e305cd57fd097c2e$var$i18n.spaceNavigationMessageLink,
    ["ACCESS_TO_SPACE"]: $e305cd57fd097c2e$var$i18n.spaceMessageLink,
    ["ACCESS_TO_PAGE"]: $e305cd57fd097c2e$var$i18n.pageMessageLink,
    ["ACCESS_TO_PAGE_CTA"]: $e305cd57fd097c2e$var$i18n.pageMessageLinkWithSeparateCallToAction
};
const $e305cd57fd097c2e$var$getPrimaryMessage = (messageType)=>{
    return $e305cd57fd097c2e$var$PRIMARY_MESSAGE[messageType] ?? $e305cd57fd097c2e$var$i18n.spaceMessageLink;
};
const $e305cd57fd097c2e$var$ANALYTICS_SOURCE_MODAL_DIALOG = 'viewExternalCollaboratorsModalDialog';
const $e305cd57fd097c2e$export$cbb9594d20a6fe04 = ({ analyticsSource: analyticsSource, messageType: messageType, shouldShowMessageIcon: shouldShowMessageIcon, shouldShowAdditionalMessageContext: shouldShowAdditionalMessageContext, spaceKey: propSpaceKey, onLoadComplete: onLoadComplete, onLoadError: onLoadError, isSubtle: isSubtle, dontRecolorGuestCount: dontRecolorGuestCount })=>{
    const spaceKey = (0, $cLo2u.useSpaceKey)(propSpaceKey);
    const spaceId = (0, $7QM6o.useSpaceId)(propSpaceKey);
    const [isModalOpen, setIsModalOpen] = (0, $42omo.useState)(false);
    const isSubtlest = !!isSubtle;
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($e305cd57fd097c2e$var$ExternalCollaboratorsSpaceInformationMessageQuery, {
        variables: {
            spaceKey: spaceKey
        }
    });
    const guestCount = data?.space?.externalCollaboratorCount ?? 0;
    (0, $42omo.useEffect)(()=>{
        if (error) onLoadError?.(error);
    }, [
        error,
        onLoadError
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!loading) onLoadComplete?.({
            guestCount: guestCount
        });
    }, [
        guestCount,
        loading,
        onLoadComplete
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onButtonClick = (0, $42omo.useCallback)((e)=>{
        e.preventDefault();
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'viewGuestsList',
                source: analyticsSource,
                containerType: 'space',
                containerId: spaceId
            }
        }).fire();
        setIsModalOpen(true);
    }, [
        createAnalyticsEvent,
        spaceId,
        analyticsSource
    ]);
    const onClose = ()=>{
        setIsModalOpen(false);
    };
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).EXTERNAL_COLLAB
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$IconWrapper, {
        hidden: !shouldShowMessageIcon
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        spacing: "spacious",
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$MessageWrapper, {
        isSubtlest: isSubtlest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $e305cd57fd097c2e$var$i18n.errorMessage)))));
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$MessageSkeleton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("br", null)));
    const CtaComponent = dontRecolorGuestCount ? $e305cd57fd097c2e$var$NullButtonWrapper : $e305cd57fd097c2e$var$MessageButtonWrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$Wrapper, null, shouldShowMessageIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eXmBZ))), {
        spacing: "spacious",
        color: "var(--ds-icon-information, #357DE8)",
        label: "info"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($e305cd57fd097c2e$var$MessageWrapper, {
        isSubtlest: isSubtlest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
        ...$e305cd57fd097c2e$var$getPrimaryMessage(messageType),
        values: {
            guestCount: guestCount,
            guests: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                ...$e305cd57fd097c2e$var$i18n.guestCallToActionMessage,
                values: {
                    guestCount: guestCount
                }
            }),
            guestCallToAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(CtaComponent, {
                "data-testid": "view-external-collaborators-link",
                isSubtlest: isSubtlest
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                appearance: "link",
                spacing: "none",
                onClick: onButtonClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                ...$e305cd57fd097c2e$var$i18n.guestCallToActionMessage,
                values: {
                    guestCount: guestCount
                }
            }))),
            callToAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $eEA8O.default), {
                appearance: "link",
                spacing: "none",
                onClick: onButtonClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), {
                ...$e305cd57fd097c2e$var$i18n.callToActionMessage,
                values: {
                    guestCount: guestCount
                }
            }))
        }
    }), shouldShowAdditionalMessageContext && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $e305cd57fd097c2e$var$i18n.additionalContextMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6xdDU.default), null, isModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $13WZn.ViewSpaceExternalCollaboratorsDialogLoadable), {
        spaceKey: spaceKey || '',
        hasHeaderImage: false,
        onClose: onClose,
        onCloseComplete: ()=>{},
        analyticsSource: $e305cd57fd097c2e$var$ANALYTICS_SOURCE_MODAL_DIALOG,
        clickSource: analyticsSource
    })));
};
module.exports["ExternalCollaboratorsSpaceInformationMessageType"] = $e305cd57fd097c2e$export$d804669af4df8a67;
module.exports["ExternalCollaboratorsSpaceInformationMessage"] = $e305cd57fd097c2e$export$cbb9594d20a6fe04;

});

parcelRegister("hdRN9", function(module, exports) {
/**
 * @generated SignedSource<<ee134fc99b05f425fd206779f25f1cdf>>
 * @relayHash 32a952014d67b0057adc7b01553cbb8d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 59aea14d53b9d666582c86e38ca652d828e911e876a43cf207a50c947919c769
const $a53bf567f7c11134$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "name"
                },
                {
                    "kind": "ScalarField",
                    "name": "externalCollaboratorCount"
                },
                {
                    "concreteType": "SpaceUserMetadata",
                    "kind": "LinkedField",
                    "name": "currentUser",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isAdmin"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ExternalCollaboratorsSpaceInformationMessageQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ExternalCollaboratorsSpaceInformationMessageQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "32a952014d67b0057adc7b01553cbb8d",
            "id": "59aea14d53b9d666582c86e38ca652d828e911e876a43cf207a50c947919c769",
            "metadata": {},
            "name": "ExternalCollaboratorsSpaceInformationMessageQuery",
            "operationKind": "query",
            "text": "query ExternalCollaboratorsSpaceInformationMessageQuery($spaceKey:String){space(key:$spaceKey){id,name,externalCollaboratorCount,currentUser{isAdmin}}}"
        }
    };
}();
$a53bf567f7c11134$var$node.hash = "930fa48aeb29519bd20c8cdd9958c15b";
var $a53bf567f7c11134$export$2e2bcd8739ae039 = $a53bf567f7c11134$var$node;
module.exports["default"] = $a53bf567f7c11134$export$2e2bcd8739ae039;

});

parcelRegister("cLo2u", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $ep3mz = parcelRequire("ep3mz");


var $7zgzO = parcelRequire("7zgzO");

function $91bacb73ef37142f$export$12ed3d1363567203(spaceKey) {
    const $ = (0, $frIzR.c)(1);
    const [pageContextSpaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const { match: match } = (0, $42omo.useContext)((0, $7zgzO.RoutesContext));
    const routesContextSpaceKey = match?.params?.spaceKey;
    if (spaceKey) return spaceKey;
    if (pageContextSpaceKey) return pageContextSpaceKey;
    if (routesContextSpaceKey) return routesContextSpaceKey;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = typeof document !== "undefined" ? document.querySelector("meta#confluence-space-key")?.content : null;
        $[0] = t0;
    } else t0 = $[0];
    const documentMetaSpaceKey = t0;
    return documentMetaSpaceKey ?? null;
}
module.exports["useSpaceKey"] = $91bacb73ef37142f$export$12ed3d1363567203;

});

parcelRegister("13WZn", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $8d0dcdd220890645$export$9a1f6434985b7141 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "2jSJc",
    name: "ViewSpaceExternalCollaboratorsDialogLoadable",
    loader: async ()=>(await (parcelRequire("2EBCF"))).ViewSpaceExternalCollaboratorsDialog
});
module.exports["ViewSpaceExternalCollaboratorsDialogLoadable"] = $8d0dcdd220890645$export$9a1f6434985b7141;

});

parcelRegister("2EBCF", function(module, exports) {

let $1eec8044ee52081d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1eec8044ee52081d$var$load("hhss7"),
    $1eec8044ee52081d$var$load("l5XQ1")
]).then(()=>parcelRequire('l9IRD'));

});

parcelRegister("buzhH", function(module, exports) {
/* ExternalCollaboratorsSpaceInformationMessageBanner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6lvbX = parcelRequire("6lvbX");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8503df358cb92af5$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt4pxbi _2rkofajl _1reo15vq _18m915vq _bfhkysee",
            __cmplp.className
        ])
    });
});
const $8503df358cb92af5$export$572064d9f672f85d = (props)=>{
    const [shouldShowExternalCollaborators, setShouldShowExternalCollaborators] = (0, $42omo.useState)(false);
    const onExternalCollaborationLoadComplete = (props)=>{
        setShouldShowExternalCollaborators(props?.guestCount > 0);
    };
    const onExternalCollaborationLoadError = ()=>{
        setShouldShowExternalCollaborators(false);
    };
    const ParentWrapper = props?.wrapper;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ParentWrapper, {
        hidden: !shouldShowExternalCollaborators
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($8503df358cb92af5$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6lvbX.ExternalCollaboratorsSpaceInformationMessage), {
        ...props,
        onLoadComplete: onExternalCollaborationLoadComplete,
        onLoadError: onExternalCollaborationLoadError
    })));
};
module.exports["ExternalCollaboratorsSpaceInformationMessageBanner"] = $8503df358cb92af5$export$572064d9f672f85d;

});

parcelRegister("lWGeX", function(module, exports) {
/* SpaceExternalListScrollable.tsx generated by @compiled/babel-plugin v0.36.1 */ /**
 * @Relay no-runtime
 */ /**
 * @graphql cc
 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $eSUdr = parcelRequire("eSUdr");


var $h82at = parcelRequire("h82at");

var $hiS1z = parcelRequire("hiS1z");


var $xQxzY = parcelRequire("xQxzY");


var $4KS7f = parcelRequire("4KS7f");


var $9hlns = parcelRequire("9hlns");


var $b3j2Y = parcelRequire("b3j2Y");


var $gvWVt = parcelRequire("gvWVt");


var $aqv4g = parcelRequire("aqv4g");


var $if3zY = parcelRequire("if3zY");

const $f64b63522d71861b$var$QUERY_PAGE_SIZE = 25; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f64b63522d71861b$var$SpinnerWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_y3gn1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f64b63522d71861b$var$RowContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx21bp4 _n3tdpxbi _j2v5idpf _11lvidpf _1xrki7uo _1vcu1r31 _15q5glyw _amo8nqa1 _17qn1r31 _1upvglyw _yrelnqa1 _6v781oa5",
            __cmplp.className
        ])
    });
});
const $f64b63522d71861b$var$UserInfoContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
});
const $f64b63522d71861b$var$i18n = (0, $h82at.defineMessages)({
    errorLoadingExternalEntities: {
        id: "space-guest-list.space-external-list-scrollable.failed-load",
        defaultMessage: "Failed to load. Please refresh."
    },
    loadMoreButton: {
        id: "space-guest-list.space-external-list-scrollable.load-more-button",
        defaultMessage: "Load more"
    }
});
function $f64b63522d71861b$export$826fff653a329e83(x) {
    return Boolean(x);
}
const $f64b63522d71861b$export$f0d50ef0c3273737 = ({ spaceKey: spaceKey, showGuestLozenge: showGuestLozenge = true })=>{
    const { data: data, loading: loading, error: error, fetchMore: fetchMore } = (0, $xQxzY.useQuery)((0, $eSUdr.default)`query SpaceExternalListScrollableSpaceExternalListQuery($spaceKey:String$start:Int$limit:Int){space(key:$spaceKey){id externalCollaboratorCount name directAccessExternalCollaborators(start:$start limit:$limit){nodes{displayName permissionType profilePicture{path}...on KnownUser{accountId email}}}}}`, {
        variables: {
            spaceKey: spaceKey,
            start: 0,
            limit: $f64b63522d71861b$var$QUERY_PAGE_SIZE
        }
    });
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $f64b63522d71861b$var$i18n.errorLoadingExternalEntities));
    const loadMore = ()=>{
        if (data?.space?.directAccessExternalCollaborators?.nodes) fetchMore({
            variables: {
                spaceKey: spaceKey,
                start: data.space.directAccessExternalCollaborators.nodes.length,
                limit: $f64b63522d71861b$var$QUERY_PAGE_SIZE
            },
            updateQuery: (prevResults, { fetchMoreResult: fetchMoreResult })=>{
                return !(fetchMoreResult && fetchMoreResult.space) ? prevResults : {
                    space: {
                        id: fetchMoreResult.space.id,
                        externalCollaboratorCount: fetchMoreResult.space.externalCollaboratorCount,
                        name: fetchMoreResult.space.name,
                        directAccessExternalCollaborators: {
                            nodes: [
                                ...prevResults.space?.directAccessExternalCollaborators?.nodes || [],
                                ...fetchMoreResult.space.directAccessExternalCollaborators?.nodes || []
                            ],
                            __typename: 'PaginatedPersonList'
                        },
                        __typename: 'Space'
                    }
                };
            }
        });
    };
    const shouldShowLoadMore = data?.space?.directAccessExternalCollaborators?.nodes && data?.space?.externalCollaboratorCount > data?.space?.directAccessExternalCollaborators?.nodes.length;
    return loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f64b63522d71861b$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9hlns.default), {
        size: "small",
        testId: "space-externallist-scrollable-loading-spinner"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", null, (data?.space?.directAccessExternalCollaborators?.nodes ?? []).filter($f64b63522d71861b$export$826fff653a329e83).map((user, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f64b63522d71861b$var$RowContainer, {
            key: user.accountId || index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($f64b63522d71861b$var$UserInfoContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aqv4g.GlobalPermissionsUserRow), {
            name: user.displayName ?? '',
            avatarSrc: user.profilePicture?.path,
            lozenge: showGuestLozenge && user.permissionType === (0, $if3zY.SitePermissionType).EXTERNAL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gvWVt.ExternalCollaboratorUserLozenge), null) : null,
            subText: user.email,
            accountId: user.accountId ?? '',
            permissionType: user.permissionType,
            showQuickActionMenu: false,
            useProfileLink: true
        })))), shouldShowLoadMore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4KS7f.default), {
        testId: "load-more-button",
        appearance: "default",
        onClick: loadMore,
        spacing: "default",
        shouldFitContainer: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hiS1z.default), $f64b63522d71861b$var$i18n.loadMoreButton)));
};
module.exports["SpaceExternalListScrollable"] = $f64b63522d71861b$export$f0d50ef0c3273737;

});

parcelRegister("gvWVt", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $4af2e88caf28e461$export$632b2aa69aba4fdd = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "iyBz0",
    name: "ExternalCollaboratorUserLozenge",
    loader: async ()=>(await (parcelRequire("h33ih"))).ExternalUserLozenge
});
module.exports["ExternalCollaboratorUserLozenge"] = $4af2e88caf28e461$export$632b2aa69aba4fdd;

});

parcelRegister("h33ih", function(module, exports) {

let $c6954595e3170e6e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c6954595e3170e6e$var$load("Wowvf"),
    $c6954595e3170e6e$var$load("h4Nf7")
]).then(()=>parcelRequire('9fywD'));

});

parcelRegister("aqv4g", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $c0727222b4e61271$export$5f22f1019f7a7dae = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ceB-9",
    name: "GlobalPermissionsUserRow",
    loader: async ()=>(await (parcelRequire("dHdou"))).UserRow
});
module.exports["GlobalPermissionsUserRow"] = $c0727222b4e61271$export$5f22f1019f7a7dae;

});

parcelRegister("dHdou", function(module, exports) {

let $9f89ae45ac57f8ee$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9f89ae45ac57f8ee$var$load("6wr18"),
    $9f89ae45ac57f8ee$var$load("iK31U"),
    $9f89ae45ac57f8ee$var$load("hwq7s"),
    $9f89ae45ac57f8ee$var$load("j104l"),
    $9f89ae45ac57f8ee$var$load("1GCFv"),
    $9f89ae45ac57f8ee$var$load("h4Nf7"),
    $9f89ae45ac57f8ee$var$load("3Zfzp"),
    $9f89ae45ac57f8ee$var$load("5uN9h"),
    $9f89ae45ac57f8ee$var$load("3WB19"),
    $9f89ae45ac57f8ee$var$load("hhss7"),
    $9f89ae45ac57f8ee$var$load("dRpV3"),
    $9f89ae45ac57f8ee$var$load("ffEVr"),
    $9f89ae45ac57f8ee$var$load("jXx9i"),
    $9f89ae45ac57f8ee$var$load("4UuEP"),
    $9f89ae45ac57f8ee$var$load("7EorR"),
    $9f89ae45ac57f8ee$var$load("Wowvf"),
    $9f89ae45ac57f8ee$var$load("cJcjb"),
    $9f89ae45ac57f8ee$var$load("9ftJe"),
    $9f89ae45ac57f8ee$var$load("hA2SB")
]).then(()=>parcelRequire('ddkba'));

});

parcelRegister("if3zY", function(module, exports) {
/* tslint:disable */ /* eslint-disable */ // This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
var $83c5dedbb8bb8ef1$export$8995abb8169b2cb8 = /*#__PURE__*/ function(SitePermissionType) {
    SitePermissionType["ANONYMOUS"] = "ANONYMOUS";
    SitePermissionType["APP"] = "APP";
    SitePermissionType["EXTERNAL"] = "EXTERNAL";
    SitePermissionType["INTERNAL"] = "INTERNAL";
    SitePermissionType["JSD"] = "JSD";
    return SitePermissionType;
}({});
module.exports["SitePermissionType"] = $83c5dedbb8bb8ef1$export$8995abb8169b2cb8;

});

parcelRegister("a04nk", function(module, exports) {
/* ExternalCollaboratorsSpaceInformationMessageFooter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $6lvbX = parcelRequire("6lvbX");

const $becefe6e669c63cc$var$Wrapper = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1yt41ejb _bfhkysee",
            __cmplp.className
        ])
    });
});
const $becefe6e669c63cc$export$2c852baa71d8f552 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($becefe6e669c63cc$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6lvbX.ExternalCollaboratorsSpaceInformationMessage), props));
module.exports["ExternalCollaboratorsSpaceInformationMessageFooter"] = $becefe6e669c63cc$export$2c852baa71d8f552;

});


//# sourceMappingURL=ExternalCollaboratorsSpaceInformationMessage.93db4465.js.map
